import { useScrollFlowWhilePlacingCore } from '__pages/AutomationEngine/Engine/Flow/hooks';
import { useContext } from 'react';
import { FlowBuilderContext } from '../context';

export const useScrollFlowWhilePlacing = () => {
  const { placing } = useContext(FlowBuilderContext);
  return useScrollFlowWhilePlacingCore(placing);
};
